import { createFileRoute } from '@tanstack/react-router'
import { ResetPassword } from '@components/ResetPassword'

function ResetPasswordComponent() {
  const { token } = Route.useSearch()

  return <ResetPassword token={token || ''} />
}

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    token: (search.token as string) || ''
  })
})
